import Tabs, { TabsProps } from "./Tabs";

export { Tabs, TabsProps };

export default Tabs;
